export class ExpedienteUtil {
    public static tipoAnalista = "ANALISTA";
    public static tipoJefeAdmision = "JEFE ADMISIÓN";
    public static tipoComite = "COMITE";
}
export type ExpedienteOpinionTipoModal = "ANALISTA" | "JEFE ADMISIÓN" | "COMITE";

